(function () {
	'use strict';
	
	angular.module('smb-app')
		.factory('smbLibraryConfigService',	[
			'$q',
			'$http',
			'pxUriPathService',
			'settingsService',
			'gettextCatalog',
			LibraryConfigService
		]);

	var path = '/libraries';

	/**
	 * @ngdoc service
	 * @name smb-app.smbLibraryConfigService
	 * 
	 * @description
	 * A service that exposes methods for configuring content type libraries.
	 */
	function LibraryConfigService($q, $http, pxUriPathService, settingsService, gettextCatalog) {

		return {
			/**
			 * @ngdoc method
			 * @name smbLibraryConfigService#getLibrary
			 * @methodOf smb-app.smbLibraryConfigService
			 * @kind function
			 * 
			 * @description
			 * Gets a single content type library by id
			 * 
			 * @param {String} libraryId The id of the library being retrieved

			 * @returns {Promise} A promise that resolves to the content type library
			 * with the matching id.
			 */
			getLibrary: getLibrary,
			/**
			 * @ngdoc method
			 * @name smbLibraryConfigService#deleteLibrary
			 * @methodOf smb-app.smbLibraryConfigService
			 * @kind function
			 * 
			 * @description
			 * Deletes a single content type library by id
			 * 
			 * @param {String} libraryId The id of the library being deleted

			 * @returns {Promise} A promise that resolves if the deleted succeeded.
			 */
			deleteLibrary: deleteLibrary,
			/**
			 * @ngdoc method
			 * @name smbLibraryConfigService#getLibraries
			 * @methodOf smb-app.smbLibraryConfigServices
			 * @kind function
			 * 
			 * @description
			 * Gets the collection of all content type libraries for the deployment
			 * 
			 * @returns {Promise} A promise that resolves to an array of content type
			 * library objects.
			 */
			getLibraries: getLibraries,

			getLibraryDetails: getLibraryDetails,

			assignUserGroupsToLibrary: assignUserGroupsToLibrary

		};

		function getLibrary(libraryId) {
			return $http.get(pxUriPathService.resolvePath(path + '/' + libraryId))
				.then(function (response) { return response.data; });
		}

		function getLibraries() {
			return $http.get(pxUriPathService.resolvePath(path))
				.then(function (response) { return response.data; });
		}

		function getLibraryDetails(library) {
			return $http.get(settingsService.serverAPIPath + '/libraries/' + library.LibraryId + '/permissions', {
			}).then(function (response) {
				return response.data;
			});
		}

		function assignUserGroupsToLibrary(acls, libraryId) {
			return $http.post(settingsService.serverAPIPath + '/libraries/' + libraryId + '/permissions/replace', acls)
			.then(function (response) {
				return response.data;
			});
		}

		function deleteLibrary(libraryId) {
			if (!libraryId) {
				return $q.reject(new Error(gettextCatalog.getString('Missing required library id')));
			}

			var uri = pxUriPathService.resolvePath('/libraries/{id}', {
				id: libraryId
			});

			return $http.delete(uri);
		}
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/services/libraryConfigService.js
// module id = 157
// module chunks = 1